import { Row, Col, Card, Divider, Table } from "antd";
import "antd/dist/antd.css";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { BACKEND_URL } from "../../../../services/backendURL";
import DashboardNewService from "../../../../services/DashboardNew/DashboardNewService";
import PartyMemberAvatar from "../../../../helpers/PartyMemberAvatar";



const LatestReferences = ({ dashboardData }) => {
    const token = useSelector((state) => state.Member.token);
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(false);


    const memberTableColumns = [
        {
            title: "#",
            dataIndex: "row_number",
            key: "row_number",
            align: "center",
            width: 50,
            render: (value) => <b>{value}</b>,
        },
        {
            title: "Anëtari",
            dataIndex: "task",
            width: 250,
            render: (text, record) => (
                <>
                    <PartyMemberAvatar
                        photo={BACKEND_URL + record.member.photo}
                        name={record.member.name}
                        surname={record.member.surname}
                        fullName={record.member.name + " " + record.member.surname}
                    />
                </>
            ),
        },
        {
            title: "Data",
            dataIndex: "membership_date",
            width: 150,
        },
    ];


    useEffect(() => {
        setLoading(true);
        DashboardNewService.getDashboardMembers(token)
            .then((response) => {
                setMembers(response.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [token]);


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Divider orientation="left" style={{ borderTopColor: "#a461d852" }} className="m-0">
                            <h4 className="m-0" style={{ color: "#a461d8" }}>Anëtarët e fundit të sugjeruar</h4>
                        </Divider>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card bodyStyle={{ padding: "0px" }} className="mt-2">
                            <div className="table-responsive">
                                <Table
                                    size="small"
                                    columns={memberTableColumns}
                                    rowKey="id"
                                    // bordered="true"
                                    dataSource={members}
                                    pagination={false}
                                    loading={loading}
                                    showHeader="true"
                                    scroll={{ x: 500 }}
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default LatestReferences;